import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e80141f2&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=e80141f2&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=e80141f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80141f2",
  null
  
)

export default component.exports